"use client";
import { memo } from "react";
import DatePickerCalendarContent from "./DatePickerCalendarContent";

const DatePickerContent = memo(
  ({
    value,
    handleDateSelect,
    defaultMonth,
    pickUpDate,
    dropOffDate,
    publicHolidays,
  }) => {
    return (
      <div className="flex h-[calc(100%-83px)] w-full flex-col">
        <DatePickerCalendarContent
          value={value}
          handleDateSelect={handleDateSelect}
          defaultMonth={defaultMonth}
          pickUpDate={pickUpDate}
          dropOffDate={dropOffDate}
          publicHolidays={publicHolidays}
        />
      </div>
    );
  },
);

DatePickerContent.displayName = "DatePickerContent";

export default DatePickerContent;
